import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterOutlet } from '@angular/router';

import { EventType } from '@shared/services/gql.service';
import { EventService } from '@shared/store/event/event.service';
import { FormValuesQuery } from '@shared/store/form-values/form-values.query';
import { WorkflowService } from '@shared/store/workflow/workflow.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
  selector: 'aux-investigator',
  template: `
    <div class="mt-7">
      <router-outlet />
    </div>
  `,
})
export class InvestigatorComponent {
  private eventService = inject(EventService);
  private formValuesQuery = inject(FormValuesQuery);
  private workflowService = inject(WorkflowService);

  constructor() {
    // Share data across investigator pages
    this.workflowService.getWorkflowList().pipe(takeUntilDestroyed()).subscribe();

    this.eventService
      .select$(EventType.TRIAL_CHANGED)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.formValuesQuery.updateValues({ site_ids: [] }, 'patientBudget');
      });
  }
}
